var _linearGradient, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturedRibbon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    viewBox: "0 0 30 40",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "99.198%",
    x2: "2.372%",
    y1: "96.692%",
    y2: "2.312%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f56185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fea76c"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m230-4h30v40l-14.963-9.686-15.037 9.686zm14.245 10.719-1.693 3.437-3.802.547a.79.79 0 0 0 -.534.313.87.87 0 0 0 -.182.573.8.8 0 0 0 .247.546l2.76 2.683-.65 3.802a.823.823 0 0 0 .117.586c.113.182.273.3.482.351a.803.803 0 0 0 .599-.078l3.411-1.769 3.411 1.77c.191.104.391.13.6.078a.765.765 0 0 0 .481-.351.823.823 0 0 0 .117-.586l-.65-3.802 2.76-2.683a.8.8 0 0 0 .247-.546.87.87 0 0 0 -.182-.573.79.79 0 0 0 -.534-.313l-3.802-.547-1.693-3.437a.792.792 0 0 0 -.456-.417c-.2-.07-.399-.07-.598 0a.792.792 0 0 0 -.456.417z",
    fill: "url(#a)",
    transform: "translate(-230 4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedRibbon);
export default __webpack_public_path__ + "static/media/featured-ribbon.0c84a9e01eb1eeccc0401cf55d547d4d.svg";
export { ForwardRef as ReactComponent };